import type { BaseType } from "../lib/api";

// What each kind of transaction is called, its section and its code. A company's own types keep their own names.
export const DOCS: Record<BaseType, { title: string; section: string; code: string }> = {
  sales: { title: "Sales invoice", section: "Sales", code: "SI01" },
  credit_note: { title: "Credit note", section: "Sales", code: "CN01" },
  receipt: { title: "Receipt", section: "Sales", code: "RC01" },
  purchase: { title: "Purchase bill", section: "Purchases", code: "PB01" },
  debit_note: { title: "Debit note", section: "Purchases", code: "DN01" },
  payment: { title: "Payment", section: "Purchases", code: "PY01" },
  contra: { title: "Transfer", section: "Banking", code: "TR01" },
  journal: { title: "Journal entry", section: "Accounting", code: "JE01" },
  opening_balance: { title: "Opening balances", section: "Accounting", code: "OB01" },
} as Record<BaseType, { title: string; section: string; code: string }>;

export const docTitle = (t: { name: string; base_type: BaseType; predefined?: boolean }) =>
  t.predefined !== false && DOCS[t.base_type] ? DOCS[t.base_type].title : t.name;
